import type { TakeoffSheet } from '../../../types/takeoff';
import { parseDrawingName } from './drawingName';

export interface ResolvedSheetFields {
  drawingNo: string | null;
  drawingName: string;
  revision: string | null;
}

/** First value with actual content, trimmed. An empty or whitespace-only column
 *  carries no meaning for a display field, so it must not beat the fallback. */
function firstNonEmpty(...vals: Array<string | null | undefined>): string | null {
  for (const v of vals) {
    const t = v?.trim();
    if (t) return t;
  }
  return null;
}

/** A card's three display fields. The reviewed title-block values written at
 *  import (`drawing_number` / `document_title` / `revision`) win; where a sheet
 *  predates that step — or the column is blank — the canonical filename parse
 *  fills in. */
export function resolveSheetFields(sheet: Pick<TakeoffSheet, 'name' | 'drawing_number' | 'document_title' | 'revision'>): ResolvedSheetFields {
  const parsed = parseDrawingName(sheet.name || '');
  return {
    drawingNo: firstNonEmpty(sheet.drawing_number, parsed.number),
    drawingName: firstNonEmpty(sheet.document_title, parsed.title, sheet.name) ?? 'Untitled sheet',
    revision: firstNonEmpty(sheet.revision, parsed.revision),
  };
}

